import usePayPerClick from '@package/hooks/src/usePayPerClick';
import { ReactNode, PropsWithChildren, useEffect } from 'react';

import { RootLayoutProps } from './types';

import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function RootLayout({
  children,
  searchComponent,
  menuComponent,
  bannerMessage,
  layoutProps,
  layoutType,
  freeSHTotalRetail,
}: PropsWithChildren<RootLayoutProps>) {
  const { handlePayPerClick } = usePayPerClick();

  useEffect(() => {
    void handlePayPerClick();
  }, []);

  return (
    <>
      <Header
        menuComponent={menuComponent}
        bannerMessage={bannerMessage ?? layoutProps?.bannerMessage}
        searchComponent={searchComponent}
        layoutType={layoutType}
        freeSHTotalRetail={freeSHTotalRetail}
      />

      {children}
      <Footer layoutType={layoutType} />
    </>
  );
}

export function renderRootLayout(page: ReactNode, props: any) {
  return (
    <RootLayout layoutProps={props} layoutType={props.layoutType} freeSHTotalRetail={props.freeSHTotalRetail}>
      {page}
    </RootLayout>
  );
}
